import React, { createContext, useState, useContext } from "react";

const TimerContext = createContext();

function TimerProvider({ children }) {
  const [remainingTime, setRemainingTime] = useState("00:00:00");

  return (
    <TimerContext.Provider value={{ remainingTime, setRemainingTime }}>
      {children}
    </TimerContext.Provider>
  );
}

const useTimer = () => {
  return useContext(TimerContext);
};

export { useTimer };
export default TimerProvider;
